<template>
  <div class="enterprise_info">
    <div class="form_content">
      <el-card>
        <div class="enterprise_info_top">
          <div class="enterprise_info_top_img imgStyle">
            <upload-image
              :imageUrl.sync="queryInfo.companyLogo"
              :imageUrls.sync="queryInfo.companyKey"
            />
            <div class="img_tip">尺寸：64*64px</div>
            <el-button v-if="queryInfo.companyLogo" @click="deleteImg">删除图片</el-button>
          </div>
          <div class="enterprise_info_top_right">
            <el-descriptions :column="num">
              <el-descriptions-item label="公司名称">
                <div class="flex no_width">
                  <i class="iconfont icon-jr-icon-company"></i>
                  <el-input
                    placeholder="请输入企业名称"
                    class="company_input"
                    v-model="queryInfo.companyFullName"
                    clearable
                  />
                  <el-select
                    class="select_input"
                    v-model="queryInfo.cooperationStatus"
                    placeholder="合作状态"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.codeId"
                      :label="item.codeName"
                      :value="item.codeName"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="法人">
                <div class="flex width">
                  <i class="iconfont icon-jr-icon-man"></i>
                  <el-input
                    placeholder="请输入法人姓名"
                    v-model="queryInfo.legalPerson"
                    clearable
                  />
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="企业简称">
                <div class="flex width">
                  <i class="iconfont icon-jr-icon-man"></i>
                  <el-input
                    placeholder="请输入企业简称"
                    class="company_input"
                    v-model="queryInfo.companyName"
                    clearable
                  />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="电话">
                <div class="flex width">
                  <i class="iconfont icon-jr-icon-phone"></i>
                  <el-input
                    placeholder="请输入电话"
                    v-model="queryInfo.companyTelephone"
                    clearable
                  />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="官网">
                <div class="flex width">
                  <i class="iconfont icon-jr-icon-information"></i>
                  <el-input placeholder="请输入官网" v-model="queryInfo.companyWebsite" clearable />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="邮箱">
                <div class="flex width">
                  <i class="iconfont icon-jr-icon-letter"></i>
                  <el-input placeholder="请输入邮箱" v-model="queryInfo.companyEmail" clearable />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="地址">
                <div class="flex width">
                  <i class="iconfont icon-jr-icon-address"></i>
                  <!-- <el-input placeholder="请输入地址" v-model="queryInfo.companyAddress" clearable /> -->
                  <!-- <span
                  >{{ queryInfo.companyProvince }}{{ queryInfo.companyCity
                  }}{{ queryInfo.companyDistrict }}</span
                > -->
                  <v-distpicker
                    @selected="onSelected"
                    :province="queryInfo.companyProvince"
                    :city="queryInfo.companyCity"
                    :area="queryInfo.companyDistrict"
                  >
                  </v-distpicker>
                  <div class="input">
                    <el-input
                      class="dutyStation"
                      v-model="queryInfo.companyAddress"
                      placeholder="请输入详细地址"
                    ></el-input>
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <div class="jianji">
              <p>公司简介：</p>
              <el-input
                :rows="3"
                v-model="queryInfo.companyBriefIntroduction"
                clearable
                type="textarea"
              />
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin-top: 12px">
        <div class="coll_div">
          <div class="coll_div_left">
            <i class="iconfont icon-jr-icon-Clock"></i>
            <p>成立时间</p>
          </div>
          <div class="coll_div_right">
            <el-date-picker
              v-model="queryInfo.companyEstablishTime"
              type="month"
              placeholder="选择月"
              value-format="yyyy-MM"
            >
            </el-date-picker>
          </div>
        </div>
        <el-collapse accordion>
          <el-collapse-item class="new_tag">
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-label"></i>
                  <p>主要成员</p>
                </div>
              </div>
              <div class="title_flex_div_right">
                <span v-for="(item, index) in queryInfo.listPrincipleMembers" :key="index">{{
                  item
                }}</span>
              </div>
            </template>
            <el-tag
              :key="index"
              v-for="(tag, index) in queryInfo.listPrincipleMembers"
              closable
              :disable-transitions="false"
              @close="handleClosePer(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisibleOne"
              v-model="inputValueOne"
              ref="saveTagInputOne"
              size="small"
              @keyup.enter.native="handleInputConfirmOne"
              @blur="handleInputConfirmOne"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputOne"
              >+ 添加</el-button
            >
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-block"></i>
                  <p>所在行业</p>
                </div>
                <div class="title_flex_div_right">
                  <span v-if="queryInfo.listIndustry.length > 0">{{
                    queryInfo.listIndustry.join()
                  }}</span>
                  <span v-else></span>
                </div>
              </div>
            </template>
            <el-checkbox-group v-model="queryInfo.listIndustry">
              <el-checkbox
                v-for="(item, index) in industryList"
                :key="index"
                :label="item.codeName"
                >{{ item.codeName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-flag"></i>
                  <p>所在城市</p>
                </div>
                <div class="title_flex_div_right">
                  <span
                    >{{ queryInfo.companyProvince }}{{ queryInfo.companyCity
                    }}{{ queryInfo.companyDistrict }}</span
                  >
                </div>
              </div>
            </template>
            <v-distpicker
              @selected="onSelected"
              :province="queryInfo.companyProvince"
              :city="queryInfo.companyCity"
              :area="queryInfo.companyDistrict"
            ></v-distpicker>
            <!-- <CascaderArea
            :country="queryInfo.companyCountry"
            :province="queryInfo.companyProvince"
            :city="queryInfo.companyCity"
            @searchArae="searchArae"
          /> -->
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-Semicircle"></i>
                  <p>融资轮次</p>
                </div>
                <div class="title_flex_div_right">
                  <span>{{ queryInfo.companyFinancingRounds }}</span>
                </div>
              </div>
            </template>
            <el-radio-group v-model="queryInfo.companyFinancingRounds">
              <el-radio
                v-for="(item, index) in financingTimesList"
                :key="index"
                :label="item.codeName"
                >{{ item.codeName }}</el-radio
              >
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-curve"></i>
                  <p>企业规模</p>
                </div>
                <div class="title_flex_div_right">
                  <span>{{ queryInfo.enterpriseScale }}</span>
                </div>
              </div>
            </template>
            <el-radio-group v-model="queryInfo.enterpriseScale">
              <el-radio
                v-for="(item, index) in enterpriseScaleList"
                :key="index"
                :label="item.codeName"
                >{{ item.codeName }}</el-radio
              >
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item class="new_tag">
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-label"></i>
                  <p>企业部门</p>
                </div>
              </div>
              <div class="title_flex_div_right">
                <span v-for="(item, index) in queryInfo.listCorporateSector" :key="index">{{
                  item
                }}</span>
              </div>
            </template>
            <el-tag
              :key="index"
              v-for="(tag, index) in queryInfo.listCorporateSector"
              closable
              :disable-transitions="false"
              @close="handleCloseTwo(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisibleTwo"
              v-model="inputValueTwo"
              ref="saveTagInputTwo"
              size="small"
              @keyup.enter.native="handleInputConfirmTwo"
              @blur="handleInputConfirmTwo"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputTwo"
              >+ 添加</el-button
            >
          </el-collapse-item>
          <el-collapse-item class="new_tag">
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-label"></i>
                  <p>荣誉标签</p>
                </div>
              </div>
              <div class="title_flex_div_right">
                <span v-for="(item, index) in queryInfo.honorLabels" :key="index">{{ item }}</span>
              </div>
            </template>
            <el-tag
              :key="index"
              v-for="(tag, index) in queryInfo.honorLabels"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput"
              >+ 添加</el-button
            >
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="title_flex_div">
                <div class="coll_div_left">
                  <i class="iconfont icon-jr-icon-curve"></i>
                  <p>经营范围</p>
                </div>
                <div class="title_flex_div_right">
                  <span>{{ queryInfo.businessScope }}</span>
                </div>
              </div>
            </template>
            <el-input
              v-model="queryInfo.businessScope"
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
            />
          </el-collapse-item>
        </el-collapse>
        <div class="business_details_foot">
          <p>来源：{{ queryInfo.source }}</p>
          <p>最近更新时间：{{ queryInfo.updateTime }}</p>
        </div>
      </el-card>
    </div>

    <div class="business_details_foot_btn">
      <el-button type="primary" @click="submitClick">确定</el-button>
      <el-button @click="clanceClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import uploadImage from '../../../../components/UploadImage.vue'
import CascaderArea from '@/components/CascaderArea.vue'
import { codeType } from '@/api/common.js'
import { saveCompanyId, updataCompanyId, getCompanyBYid } from '@/api/enterprise.js'
export default {
  components: { uploadImage },
  name: 'enterpriseInfo',
  data() {
    return {
      num: 2, //列表2个一行
      options: [], //合作
      industryList: [], //所在行业
      financingTimesList: [], //融资轮次
      enterpriseScaleList: [], //企业规模
      queryInfo: {
        businessScope: '', //经营范围
        listCorporateSector: [], //企业部门集合
        corporateSector: '',
        listPrincipleMembers: [], //主要成员集合
        principleMembers: '',
        legalPerson: '', //法人
        companyAddress: '', //公司详细地址
        companyBriefIntroduction: '', //公司简介
        companyCity: '', //所属城市
        companyDistrict: '', //所属区域
        companyCode: '', //企业编号
        companyCountry: '', //所属国家
        companyEmail: '', //公开邮箱
        companyEstablishTime: '', //公司成立时间
        companyFinancingRounds: '', //公司当前融资轮次
        companyFullName: '', //公司全称
        companyName: '', //公司简称
        companyKey: '', //公司logo完整路径
        companyLogo: '', //公司logo
        companyProvince: '', //所属省份
        companyTelephone: '', //公开电话
        companyWebsite: '', //公司官网网址
        cooperationStatus: '', //合作状态
        createName: '', //创建人名字
        createTime: '', //创建时间
        enterpriseScale: '', //企业规模
        honorLabel: '', //荣誉标签
        honorLabels: [], //
        listIndustry: [], //
        updateName: '', //修改人名字
        updateTime: '' //修改时间
      },
      //荣耀标签
      inputVisible: false,
      inputValue: '',
      //主要成员
      inputVisibleOne: false,
      inputValueOne: '',
      //企业部门
      inputVisibleTwo: false,
      inputValueTwo: ''
    }
  },
  computed: {
    //0新增 1编辑
    enterpriseType() {
      return Number(this.$route.query.enterpriseType)
    },
    companyCode() {
      return this.$route.query.companyCode
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    //获取合作状态
    this.cooperation()
    //所在行业
    this.industry()
    //融资次数
    this.financingTimes()
    //企业规模
    this.enterpriseScale()
    if (this.enterpriseType === 1) {
      //编辑回显展示单个
      this.querySingle()
    }
  },
  methods: {
    //查询单个数据
    async querySingle() {
      const { data: res } = await getCompanyBYid({ companyCode: this.companyCode })
      // console.log("编辑企业",res)
      if (res.resultCode === 200) {
        Object.assign(this.queryInfo, res.data)
        if (!this.queryInfo.listIndustry) {
          this.queryInfo.listIndustry = []
        }
        if (!this.queryInfo.listPrincipleMembers) {
          this.queryInfo.listPrincipleMembers = []
        }
        if (!this.queryInfo.listCorporateSector) {
          this.queryInfo.listCorporateSector = []
        }
      }
    },
    //新增、编辑
    async submitClick() {
      const fn = this.enterpriseType === 1 ? updataCompanyId : saveCompanyId
      const txt = this.enterpriseType === 1 ? '修改' : '新增'
      if (!this.queryInfo.companyFullName) {
        this.$message.error('请输入企业名称')
      } else if (!this.queryInfo.companyName) {
        this.$message.error('请输入企业简称')
      } else {
        const { data: res } = await fn(this.queryInfo)
        if (res.resultCode === 200) {
          this.$message.success(txt + '成功!')
          this.$router.go(-1)
        } else {
          this.$message.error(res.message)
        }
      }
    },
    //取消
    clanceClick() {
      this.$router.go(-1)
    },
    //工作地址
    onSelected(data) {
      console.log('地区', data)
      // 设置地址的省市区
      this.queryInfo.companyProvince = data.province.value
      this.queryInfo.companyCity = data.city.value
      this.queryInfo.companyDistrict = data.area.value
    },
    //地区
    searchArae(val) {
      this.queryInfo.companyCountry = val.country

      this.queryInfo.companyProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.companyCity = val.city
      }
      //this.queryInfo.companyAddress = val.country + val.province + val.city
    },
    //荣誉标签
    handleClose(tag) {
      this.queryInfo.honorLabels.splice(this.queryInfo.honorLabels.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.queryInfo.honorLabels.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    //主要 成员
    handleClosePer(tag) {
      this.queryInfo.listPrincipleMembers.splice(
        this.queryInfo.listPrincipleMembers.indexOf(tag),
        1
      )
    },
    showInputOne() {
      this.inputVisibleOne = true
      this.$nextTick(() => {
        this.$refs.saveTagInputOne.$refs.input.focus()
      })
    },
    handleInputConfirmOne() {
      let inputValueOne = this.inputValueOne
      if (inputValueOne) {
        this.queryInfo.listPrincipleMembers.push(inputValueOne)
      }
      this.inputVisibleOne = false
      this.inputValueOne = ''
    },
    //企业部门
    handleCloseTwo(tag) {
      this.queryInfo.listCorporateSector.splice(this.queryInfo.listCorporateSector.indexOf(tag), 1)
    },
    showInputTwo() {
      this.inputVisibleTwo = true
      this.$nextTick(() => {
        this.$refs.saveTagInputTwo.$refs.input.focus()
      })
    },
    handleInputConfirmTwo() {
      let inputValueTwo = this.inputValueTwo
      if (inputValueTwo) {
        this.queryInfo.listCorporateSector.push(inputValueTwo)
      }
      this.inputVisibleTwo = false
      this.inputValueTwo = ''
    },
    //获取合作状态
    async cooperation() {
      const { data: res } = await codeType({ code: '001' })
      this.options = res.data
    },
    //所在行业
    async industry() {
      const { data: res } = await codeType({ code: '004' })
      this.industryList = res.data
    },
    //融资次数
    async financingTimes() {
      const { data: res } = await codeType({ code: '002' })
      this.financingTimesList = res.data
    },
    //企业规模
    async enterpriseScale() {
      const { data: res } = await codeType({ code: '006' })
      this.enterpriseScaleList = res.data
    },
    deleteImg() {
      ;(this.queryInfo.companyLogo = ''), (this.queryInfo.companyKey = '')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .distpicker-address-wrapper select {
  min-width: 200px;
}
.imgStyle {
  text-align: center;
  /deep/ .el-button {
    padding: 5px 10px;
    border-color: #17757a;
    color: #17757a;
  }
}
.enterprise_info {
  width: 100%;
  position: relative;

  .form_content {
    height: calc(100vh - 128px - 72px);
    overflow: auto;
    padding-bottom: 72px;
  }

  .business_details_foot_btn {
    // display: flex;
    // flex-direction: row;
    // justify-content: center;
    // align-items: center;
    // margin: 20px auto;
    display: flex;
    margin-top: 50px;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 72px;
    left: 0;
    bottom: -10px;
    background: #fff;
    width: 100%;
    box-shadow: 0px 0px 4px 0px #00000040;

    /deep/ .el-button--primary {
      background-color: #17757a;
      border-color: #17757a;
    }
  }

  .title_flex_div {
    display: flex;
    flex-direction: row;
  }

  .title_flex_div_right {
    margin-left: 50px;

    span {
      margin-right: 12px;
      color: #444444;
      font-size: 14px;
    }
  }

  .new_tag {
    .el-tag + .el-tag {
      margin-left: 10px;
    }
    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }

  /deep/ .el-radio {
    margin-bottom: 10px;
  }

  /deep/.el-collapse-item__content {
    padding-bottom: 12px;
  }

  .business_details_foot {
    width: 100%;
    overflow: hidden;
    margin-top: 20px;

    p {
      color: #999999;
      font-size: 12px;
      margin-top: 4px;
      line-height: 1.5em;
    }
  }

  .enterprise_info_top {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .jianji {
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      p {
        text-align: left;
        font-weight: 400;
        color: #606266;
        font-size: 14px;
        width: 80px !important;
      }

      .el-textarea__inner {
        flex: 1;
      }
    }

    /deep/.width .el-input__inner {
      width: 280px;
    }

    /deep/ .jianji .el-input__inner {
      width: 100%;
    }

    /deep/ .company_input {
      width: 250px !important;
      margin-right: 10px;
    }

    /deep/ .select_input {
      width: 120px !important;
      // margin-left: 10px;
    }

    .flex {
      display: flex;
      flex-direction: row;
      align-items: center;

      i {
        color: #17757a;
        font-size: 16px;
        margin-right: 18px;
      }
    }

    /deep/ .el-descriptions-item__label:not(.is-bordered-label) {
      line-height: 40px;
    }

    .enterprise_info_top_img {
      margin-right: 30px;
    }
    /deep/ .el-upload.el-upload--text img {
      vertical-align: top;
    }
    .img_tip {
      margin: 5px 0;
      font-family: PingFang SC;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      letter-spacing: 0em;
      text-align: center;
      color: rgba(140, 135, 135, 1);
    }
    .enterprise_info_top_right {
      flex: 1;
      overflow: hidden;
    }
  }

  .coll_div_left {
    display: flex;
    overflow: hidden;
    flex-direction: row;
    i {
      color: #17757a;
      font-size: 16px;
      margin-right: 8px;
    }

    p {
      color: #000000;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .coll_div {
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    line-height: 50px;
    display: flex;
    flex-direction: row;

    .coll_div_right {
      flex: 1;
      margin-left: 42px;

      /deep/.el-date-editor.el-input {
        width: 160px;
      }
    }
  }
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .form_content {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 14px !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .form_content {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 164px !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .form_content {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 296px !important;
  }
}

// 1280x1024 (1280x863)
@media (max-width: 1282px) and (max-height: 864px) {
  .form_content {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 40px !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .form_content {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 106px !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 262px !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 296px !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 342px !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 464px !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 198px !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 294px !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .form_content {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .business_details_foot_btn {
    bottom: 462px !important;
  }
}
</style>
